export default {
  apiBaseUrl: 'https://clcgiving.xyz/api/',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  accessDeniedPath: '/access-denied',
  expires: 365,
  secure: true
};
